import { Config } from "./types";

export const EMPLOYEE_CONFIG: Config[] = [
  {
    text: "STT",
    type: "number",
    field: "rowId",
    width: 100,
    defaultText: "1",
    required: true,
  },
  {
    text: "Code",
    type: "text",
    field: "code",
    defaultText: "Code",
    required: true,
  },
  {
    text: "Email",
    type: "text",
    field: "email",
    regex: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/,
    defaultText: "test@email.com",
    required: true,
    errorMessage: "Email is invalid",
  },
  {
    text: "Phone Number",
    type: "text",
    field: "phoneNumber",
    regex: /^[0-9]{10}$/,
    defaultText: "0123456789",
    errorMessage: "Phone number is invalid",
  },
  {
    text: "First name",
    type: "text",
    field: "firstName",
    defaultText: "First name",
    required: true,
  },
  {
    text: "Last name",
    type: "text",
    field: "lastName",
    defaultText: "Last name",
    required: true,
  },
  {
    text: "Date of birth",
    type: "date",
    field: "dateOfBirth",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date of birth is invalid",
  },
  {
    text: "Gender",
    type: "text",
    field: "gender",
    defaultText: "Male/Female/Other",
    required: true,
    regex: /^(Male|Female|Other)$/,
    errorMessage: "Gender is invalid",
  },
  {
    text: "Department Code",
    type: "text",
    field: "departmentCode",
    defaultText: "Department Code",
    required: true,
  },
  {
    text: "Manager Code",
    type: "text",
    field: "managerCode",
    defaultText: "Manager Code",
  },
  {
    text: "Title",
    type: "text",
    field: "title",
    defaultText: "Title",
    required: true,
  },
  {
    text: "Title Code",
    type: "text",
    field: "titleCode",
    defaultText: "Title Code",
    required: true,
  },
  {
    text: "Material Status",
    type: "text",
    field: "materialStatus",
    defaultText: "Single/Married/Divorced/Widowed|Other",
    regex: /^(Single|Married|Divorced|Widowed|Other)$/,
  },
  {
    text: "Personal Email",
    type: "text",
    field: "personalEmail",
    defaultText: "",
  },
  {
    text: "Is Expat",
    type: "boolean",
    field: "isExpat",
    defaultText: "true/false",
  },
  {
    text: "First working date",
    type: "date",
    field: "firstWorkingDate",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "First working date is invalid",
  },
  {
    text: "Last working date",
    type: "date",
    field: "lastWorkingDate",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Last working date is invalid",
  },
  {
    text: "Employment type",
    type: "text",
    field: "employmentType",
    defaultText: "FTE/PTE/ITE/APE/TEM/CON/TTP",
    regex: /^(FTE|PTE|ITE|APE|TEM|CON|TTP)$/,
  },
  {
    text: "Employment status",
    type: "text",
    field: "employmentStatus",
    defaultText:
      "Probationary/Termination/Working/Maternity/LongTermLeave/LongTermSL/LongTermUL",
    regex:
      /^(Probationary|Termination|Working|Maternity|LongTermLeave|LongTermSL|LongTermUL)$/,
  },
  {
    text: "Contract No",
    type: "text",
    field: "contractNo",
    defaultText: "Contract no",
  },
  {
    text: "Contract start date",
    type: "date",
    field: "contractStartDate",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Contract start date is invalid",
  },
  {
    text: "Contract end date",
    type: "date",
    field: "contractEndDate",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Contract end date is invalid",
  },
  {
    text: "Contract notice period",
    type: "number",
    field: "contractNoticePeriod",
    defaultText: "Contract notice period",
  },

  {
    text: "Probation start date",
    type: "date",
    field: "probationStartDate",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Probation start date is invalid",
  },
  {
    text: "Probation end date",
    type: "date",
    field: "probationEndDate",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Probation end date is invalid",
  },
  {
    text: "Probation period",
    type: "number",
    field: "probationPeriod",
    defaultText: "Probation period",
  },
  {
    text: "Tax code",
    type: "text",
    field: "taxCode",
    defaultText: "Tax code",
  },
  {
    text: "Tax object type",
    type: "text",
    field: "taxObjectType",
    regex: /^(Resident|NonResident)$/,
    defaultText: "Resident/NonResident",
  },
  {
    text: "Is authorize tax finalization",
    type: "boolean",
    field: "isAuthorizeTaxFinalization",
    defaultText: "Is authorize tax finalization",
  },
  {
    text: "HRBP Code",
    type: "text",
    field: "hrbpCode",
    defaultText: "HRBP Code",
  },
  {
    text: "Work level code",
    type: "text",
    field: "workLevelCode",
    defaultText: "Work level code",
  },
  {
    text: "Contract type code",
    type: "text",
    field: "contractTypeCode",
    defaultText: "Contract type code",
  },
  {
    text: "Branch code",
    type: "text",
    field: "branchCode",
    defaultText: "Branch code",
  },
];
